import { PropsWithChildren, useCallback } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { ProductViewModel } from '@/types/api';
import { PDPPageVariantContext } from './context';
import { useProductVariantCore } from '../use-product-variant-core';
interface Props extends PropsWithChildren {
  product?: ProductViewModel;
  isLoading: boolean;
}
const PDPPageVariantProvider = ({
  children,
  product,
  isLoading
}: Props) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const stringifiedSearchParams = searchParams.toString();
  const selectedAtpId = searchParams.get('atpId');
  const variantUpdateHandler = useCallback((atpId: string | null) => {
    const params = new URLSearchParams(stringifiedSearchParams);
    if (atpId) {
      params.set('atpId', atpId);
    } else {
      params.delete('atpId');
    }
    const url = `${pathname}?${params.toString()}`;
    router.replace(url, {
      scroll: false
    });
  }, [pathname, router, stringifiedSearchParams]);
  const coreValues = useProductVariantCore({
    product,
    isLoading,
    selectedAtpId,
    variantUpdateHandler
  });
  return <PDPPageVariantContext.Provider value={coreValues} data-sentry-element="unknown" data-sentry-component="PDPPageVariantProvider" data-sentry-source-file="provider.tsx">{children}</PDPPageVariantContext.Provider>;
};
export default PDPPageVariantProvider;